// extracted by mini-css-extract-plugin
export var banner = "_sk-0";
export var settingRow = "_sk-2";
export var titleIcon = "_sk-1";